export default {
    1: {
        id: 1,
        text: 'Autorización',
        type: 'authorization'
    },
    2: {
        id: 1,
        text: 'Cobranza',
        type: 'collection'
    },
    3: {
        id: 1,
        text: 'Ajuste Socio',
        type: 'partner_adjustment'
    },
    4: {
        id: 1,
        text: 'Rechazo',
        type: 'rejection'
    },
    5: {
        id: 1,
        text: 'Anulación',
        type: 'cancellation'
    },
};
